import { Sha256 } from './sha256';
import type { IntegrityResult } from './types';

/**
 * Stream a Blob/File through SHA-256 without buffering it. Reading the finalized
 * output back (rather than hashing during receive) keeps verification correct
 * even when a transfer was resumed across a page reload.
 */
export async function hashBlobStreaming(blob: Blob): Promise<string> {
  const hasher = new Sha256();
  const reader = blob.stream().getReader();
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    hasher.update(value);
  }
  return hasher.digestHex();
}

export function compareHash(expected: string, actual: string): IntegrityResult {
  if (!expected) return 'skipped';
  return expected.toLowerCase() === actual.toLowerCase() ? 'verified' : 'corrupted';
}
